export const FullPageLoader = () => {
 return <div className="up-fullloader">
 {/* <span className="loader"></span> */}
 <div className="lds-dual-ring"></div>
</div>
}